/* Which server is this?
 *
 * The expensive mistake in a multi-environment setup is not knowing which one
 * you are looking at while you delete something. The server says which
 * environment it is at /api/version, defaulting to production; this shows a
 * badge whenever it is anything else, and nothing at all on production, so the
 * badge keeps its meaning.
 */

import { useEffect, useState } from 'react';
import { get } from '../api';

export default function EnvBadge() {
  const [env, setEnv] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    void get<{ env?: string }>('/api/version').then(r => {
      if (live && r.ok && typeof r.env === 'string') setEnv(r.env);
    });
    return () => { live = false; };
  }, []);

  if (!env || env === 'prod') return null;
  return (
    <span className="env-badge" role="note" title={`You are on the ${env} server, not production.`}>
      {env.toUpperCase()}
    </span>
  );
}
